<div class="eye-view-consignor mb-2">
  <div class="row eye-view-consignor-row">
    <div class="col-4 mogo-bold text-end eye-view-consignor-header">
      Site From
    </div>
    <div class="col-8 eye-view-consignor-content">
      {{ fromJobAddress?.name}}
    </div>
  </div>
  <div class="row eye-view-consignor-row">
    <div class="col-4 mogo-bold text-end eye-view-consignor-header">
      Address
    </div>
    <div class="col-8 eye-view-consignor-content">
      {{ fromJobAddress?.address}}
    </div>
  </div>
  <div class="row ">
    <div class="col-4 mogo-bold text-end eye-view-consignor-header">
      Site Contact
    </div>
    <div class="col-8 eye-view-consignor-content">
      Name: {{ fromJobContact?.name || '' }}<br>
      Phone: {{ fromJobContact?.phone || '' }}<br>
      Email: {{ fromJobContact?.email || '' }}
    </div>
  </div>
</div>